import React from "react";
import { Field, ErrorMessage, Formik, Form, FieldArray } from "formik";
import HelperText from "components/shared/HelperText/HelperText";
import InputField from "components/shared/InputField/InputField";
import { Button } from "components";
import UserProfileHeading from "../components/UserProfileHeading/UserProfileHeading";
import { Select } from "antd";
import SelectField from "components/shared/SelectField/SelectField";
import { SecurityQuestion } from "../components/models";
import { securityQestionsValidationSchema } from "./validationSchemas";

interface SecurityProps {
  questions: SecurityQuestion[];
  onClose?: (v: typeof initialValues) => void;
}
const initialValues = {
  securityAnswers: [
    {
      SecurityQuestionId: "",
      Answer: "",
    },
    // {
    //   SecurityQuestionId: "",
    //   Answer: "",
    // },
    // {
    //   SecurityQuestionId: "",
    //   Answer: "",
    // },
  ],
};

const SecurityQuestions: React.FC<SecurityProps> = ({ questions, onClose }) => {
  const { Option } = Select;

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        if (typeof onClose === "function") {
          onClose(values);
        }
      }}
      validationSchema={securityQestionsValidationSchema}
    >
      {({ values, dirty, isValid, errors, handleSubmit }) => (
        <Form
          className="user-profile-form"
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          {/* <UserProfileHeading title="Security Questions" /> */}
          <FieldArray name="securityAnswers">
            {() => (
              <>
                <div className="">
                  <div className="form-group">
                    <label>
                      Question 1<span className="danger mandatory">*</span>
                    </label>
                    <Field
                      name={`securityAnswers.0.SecurityQuestionId`}
                      component={SelectField}
                      required
                      autoComplete="off"
                    >
                      {questions
                        // .filter(
                        //   (ele) =>
                        //     ele.securityQuestionId !==
                        //       +values["securityAnswers"][2][
                        //         "SecurityQuestionId"
                        //       ] &&
                        //     ele.securityQuestionId !==
                        //       +values["securityAnswers"][1][
                        //         "SecurityQuestionId"
                        //       ]
                        // )
                        .map((val, i) => (
                          <Option key={i} value={val.securityQuestionId}>
                            {val.Question}
                          </Option>
                        ))}
                    </Field>
                    <ErrorMessage name={`securityAnswers.0.SecurityQuestionId`}>
                      {(msg: string) => <HelperText>{msg}</HelperText>}
                    </ErrorMessage>
                  </div>
                  <div className="form-group"> 
                    <Field
                      component={InputField}
                      name={`securityAnswers.0.Answer`}
                      label="Answer"
                      type="text"
                      autoComplete="off"
                    />

                    <ErrorMessage name={`securityAnswers.0.Answer`}>
                      {(msg: string) => <HelperText>{msg}</HelperText>}
                    </ErrorMessage>
                  </div>
                </div>
                {/* <div className="">
                  <div className="form-group">
                    <label>
                      Question 2<span className="danger mandatory">*</span>
                    </label>
                    <Field
                      name={`securityAnswers.1.SecurityQuestionId`}
                      component={SelectField}
                      required
                      autoComplete="off"
                    >
                      {questions
                        .filter(
                          (ele) =>
                            ele.securityQuestionId !==
                              +values["securityAnswers"][0][
                                "SecurityQuestionId"
                              ] &&
                            ele.securityQuestionId !==
                              +values["securityAnswers"][2][
                                "SecurityQuestionId"
                              ]
                        )
                        .map((val, i) => (
                          <Option key={i} value={val.securityQuestionId}>
                            {val.Question}
                          </Option>
                        ))}
                    </Field>
                    <ErrorMessage name={`securityAnswers.1.SecurityQuestionId`}>
                      {(msg: string) => <HelperText>{msg}</HelperText>}
                    </ErrorMessage>
                  </div>
                  <div className="form-group">
                    <Field
                      component={InputField}
                      name={`securityAnswers.1.Answer`}
                      label="Answer"
                      type="text"
                      autoComplete="off"
                    />

                    <ErrorMessage name={`securityAnswers.1.Answer`}>
                      {(msg: string) => <HelperText>{msg}</HelperText>}
                    </ErrorMessage>
                  </div>
                </div>
                <div className="">
                  <div className="form-group">
                    <label>
                      Question 3<span className="danger mandatory">*</span>
                    </label>
                    <Field
                      name={`securityAnswers.2.SecurityQuestionId`}
                      component={SelectField}
                      required
                      autoComplete="off"
                    >
                      {questions
                        .filter(
                          (ele) =>
                            ele.securityQuestionId !==
                              +values["securityAnswers"][0][
                                "SecurityQuestionId"
                              ] &&
                            ele.securityQuestionId !==
                              +values["securityAnswers"][1][
                                "SecurityQuestionId"
                              ]
                        )
                        .map((val, i) => (
                          <Option key={i} value={val.securityQuestionId}>
                            {val.Question}
                          </Option>
                        ))}
                    </Field>
                    <ErrorMessage name={`securityAnswers.2.SecurityQuestionId`}>
                      {(msg: string) => <HelperText>{msg}</HelperText>}
                    </ErrorMessage>
                  </div>
                  <div className="form-group">
                    <Field
                      component={InputField}
                      name={`securityAnswers.2.Answer`}
                      label="Answer"
                      type="text"
                      autoComplete="off"
                    />

                    <ErrorMessage name={`securityAnswers.2.Answer`}>
                      {(msg: string) => <HelperText>{msg}</HelperText>}
                    </ErrorMessage>
                  </div>
                </div> */}
              </>
            )}
          </FieldArray>

          <div className="flex" style={{ height: "2.5rem" }}>
            <Button
              variant="primary"
              type="submit"
              label="Save"
              disabled={!dirty || !isValid}
            />
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default SecurityQuestions;
